import styled from "styled-components";

import { box } from "../../SharedComponents/Box";

const Form = styled.form`
  ${box}
`;
export default Form;
